// extracted by mini-css-extract-plugin
export default {"component":"page_component__jZlNj","adminBtn":"page_adminBtn__-p0ee"};